import { authenticatedFetch } from '../../api/request';

export default async function processPlanUpgrade(
    nonce: string,
    orgId: number,
    newCoachLicenseId: number,
    paymentMethodId: string = ''
) {
    return authenticatedFetch(`/v5/orgs/${orgId}/subscriptions/upgrade`, {
        method: 'PUT',
        body: JSON.stringify({ nonce, newCoachLicenseId, paymentMethodId })
    });
}
